import { QueryClient } from "@tanstack/react-query";

const isClient = typeof window !== "undefined";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // gcTime: isClient ? 5 * 60 * 1000 : 0, // (2 minutes) no caching during SSR to prevent hydration errors
      cacheTime: isClient ? 5 * 60 * 1000 : 0, // (5 minutes) no caching during SSR to prevent hydration errors
      staleTime: isClient ? 2 * 60 * 1000 : 0, // (2 minutes) to keep results fresh during the client phase
    },
  },
});

export const refetchPageQuery = () => {
  queryClient.refetchQueries({
    queryKey: ["page"],
    exact: false,
  });
};
